<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/155fRNH/tc-custom/9781455614011.jpg?1742447020628" alt="This image is the cover for the book Weep Not for Me, Dear Mother"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Weep Not for Me, Dear Mother
      </h1>
      <p class="bookDescription body article font2">
        <p>ACCELERATED READER PROGRAM SELECTIONCHILDREN'S BOOK COUNCIL NOTABLE CHILDREN'S TRADE BOOK IN THE FIELD OF SOCIAL STUDIES FOR 1997</p><p>"Ms. Roberson brings to life Eli Landers and his family in this truly outstanding book." -Civil War Courier</p><p>"I expect to be a man of honor to our country at the risk to my life." -Pvt. Eli Pinson Landers, letter dated September 24, 1863, camp near Chattanooga, TN</p><p>When her neighbor handed her a stack of yellowed letters that had been rescued from an Atlanta, Georgia, trash pile , author Elizabeth Whitley Roberson had no idea she was about to embark on a fact-finding mission through six states, from Civil War battlegrounds in Pennsylvania, Maryland, and Virginia to Gwinnett County in North Georgia. The author of these letters was a young man named Eli Pinson Landers, a Confederate soldier in the Civil War. Weep Not For Me, Dear Mother is a collection of the letters this brave young man diligently wrote to his mother, Susan Landers, back in their home of Yellow River, Georgia. The book traces his life in battles at Gettysburg, Manassas, and Chickamauga, among others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Roberson
      </h2>
      
      <p class="authorDescription body article">Elizabeth Whitley Roberson often addresses historical groups such as the Sons of Confederate Veterans, United Daughters of the Confederacy, and Daughters of the American Revolution. She is widely published in magazines and journals, including Tar Heel magazine, Blue and Gray Magazine, and the New East Magazine. Roberson holds degrees in education and history and resides in her native Williamston, North Carolina.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31ffd47a